"use client";

import dynamic from "next/dynamic";
import { Skeleton } from "@/components/ui/skeleton";

const OrdersClient = dynamic(() => import("./OrdersClient"), {
  ssr: false,
  loading: () => (
    <div className="flex min-h-[60vh] flex-col items-center justify-center gap-3 px-6 text-center">
      <Skeleton className="h-64 w-96" />
      {/*
        Without this a visitor with JavaScript off (or blocked by an extension,
        or on a corporate proxy that strips the chunk) sat in front of a
        skeleton FOREVER, with nothing on screen saying why or what to do —
        `ssr: false` means the server HTML is only ever this fallback. `/checkout`
        already carried the same note; this page did not. It genuinely requires
        JS (it reads the saved order codes out of local storage and exchanges a
        magic-link token), so explaining is the right degradation, not SSR.
      */}
      <noscript>
        <p className="max-w-md text-sm text-muted-foreground">
          JavaScript is required to look up your orders. Enable JavaScript and reload,
          or use the order code and email link we sent you.
        </p>
      </noscript>
    </div>
  ),
});

export default function Page() {
  return <OrdersClient />;
}
